import { putanjaIzUrla } from '../pwa/pwa-rute';

/**
 * Osobni link klijenta (`/k` i sve ispod `/k/`, npr. `/k/<token>/odjava`): token u adresi je tajna
 * (pristup upitu bez prijave). Takva adresa ne smije otići trećim stranama (GA4, Meta Pixel), u
 * Referer ni u tražilice. `/kontakt` i `/kx` nisu osobni link.
 *
 * Prima URL routera ili putanju iz `location` (s upitom ili sidrom ili bez njih).
 */
export function jeOsobniLinkKlijenta(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  const putanja = putanjaIzUrla(url);
  return putanja === '/k' || putanja.startsWith('/k/');
}

/** Je li preglednik upravo na osobnom linku (adresna traka; izvan preglednika `false`). */
export function preglednikJeNaOsobnomLinku(): boolean {
  return typeof window !== 'undefined' && jeOsobniLinkKlijenta(window.location?.pathname);
}
